/** The Understanding page's views, apart so the route's address check carries nothing else. */
export const UNDERSTAND_TABS = ["all", "areas", "terms", "traps", "check", "map"] as const;
export type UnderstandTab = (typeof UNDERSTAND_TABS)[number];

/** The Understanding address: the view (`?view=`), one area in depth, the find box's words, one item to open. */
export type UnderstandSearch = {
  view?: UnderstandTab | "overview";
  area?: string;
  q?: string;
  item?: string;
};
